import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    makeStyles,
    Paper,
    Grid,
    Dialog,
    AppBar,
    Toolbar,
    Slide,
    IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import ApproveLeaveForm from '../../LeaveApplication/component/Form';
import RecentLeave from '../../LeaveApplication/component/RecentLeave';
import RecentLeaveCollection from '../../Function/RecentLeaveCollection';
import customAxios from '../../../components/API/customAxios';
import Details from '../../../components/MyLeave/component/Details';
import { useIntl } from 'react-intl';
import { checkUndefined } from '../../Function/globalFunction';
import MiniTable from '../../UIComponent/MiniTable';
import CompLeaveCollection from '../../Function/CompLeaveCollection';
import ApproveCompLeaveForm from '../../CompLeaveRequest/component/Form';
import { Container } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: '#232F3E',
    },
    modal: {
        display: 'flex',
        padding: theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: '#f0f2f5',
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
    },
    subPaper: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
});

export default function Approve({ approveMode, handleClose, open, showId, tabIndex }) {
    const mode = window.global.approveMode;
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [application, setApplication] = React.useState({});
    const [showBalance, setShowBalance] = React.useState(false);
    const [showDetail, setShowDetail] = React.useState(false);
    const [rows, setRows] = React.useState([]);
    const [compLeaveRows, setCompLeaveRows] = React.useState([]);
    const [employeeDuty, setEmployeeDuty] = React.useState('');

    React.useEffect(() => {
        customAxios.get(`/get_comp_leave_req/` + showId).then(
            (res) => {
                if (String(res.data.status) !== window.global.withdrawn) {
                    setShowDetail(true);
                } else {
                    setShowDetail(false);
                }

                setApplication(res.data);

                setCompLeaveRows(
                    CompLeaveCollection(res.data['comp_leave_balance'], intl)
                );
                setShowCompetent(true);
                setEmployeeDuty(res.data['staff_duty']);
            },
            (error) => {
                history.push('/home');
            }
        );
    }, []);

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    backgroundColor: '#f0f2f5',
                    boxShadow: 'none',
                },
            }}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge='start'
                        color='inherit'
                        onClick={handleClose}
                        aria-label='close'
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Container 
                className={classes.container}
                maxWidth='xxl'
            >
                {showCompetent ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={9}>
                            <Paper className={classes.mainPaper}>
                                <ApproveCompLeaveForm
                                    mode={mode}
                                    application={application}
                                    approveMode={approveMode}
                                    approveId={showId}
                                    tabIndex={tabIndex}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={12} lg={3}>
                            <Paper className={classes.subPaper}>
                                <MiniTable rows={compLeaveRows} staffDuty={application?.staff_duty} />
                            </Paper>
                            {showDetail && (
                                <Paper className={classes.subPaper}>
                                    <Details
                                        handleClose={null}
                                        open={null}
                                        showId={application.id}
                                        page='Approve Comp Leave Req'
                                    />
                                </Paper>
                            )}
                        </Grid>
                    </Grid>
                ) : (
                    <div className={classes.circularProgress}>
                        <CircularProgress />
                    </div>
                )}
            </Container>
        </Dialog>
    );
}
